import React, { useRef } from "react";
import Button from "@mui/material/Button";

const GradiantButton = ({
  text,
  className,
  onClick,
  style,
  btnColor,
  btnTextColor = "white",
  Icon,
  disabled,
  borderColor,
  endIcon,
  height,
  width,
  isUpolad,
  FileUpload,
  Filetype,
  // isborder,/
}) => {
  const fileInputRef = useRef(null);
  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        zIndex:100
      }}
    >
      <Button
        variant="contained"
        className={`${className} ${
          btnColor ? btnColor : "GradiantButton border-0"
        } `}
        // onClick={onClick}
        onClick={onClick ? onClick : handleFileUpload}
        startIcon={Icon ? Icon : ""}
        endIcon={endIcon ? endIcon : ""}
        disabled={disabled ? disabled : false}
        sx={{
          height: height ? height : "45px",
          zIndex:1,
          background: btnColor ? btnColor :
            "linear-gradient(66deg, #245BE7 -13.26%, #8D9CC4 166.56%)",
          color: btnTextColor,
          textTransform: "none",
          border: 1,
          width: width ? width : "100%",
          borderColor: borderColor ? borderColor : btnColor,
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: btnColor, // or any other desired color
          },
          "&:disabled": {
            color: btnTextColor,
            backgroundColor: btnColor,
            opacity: 0.5,
          },
        }}
        style={{ style }}
      >
        <span
          className="py-2"
          style={{ fontSize: "16px", fontFamily: "PoppinsSemiBold" }}
        >
          {text}
        </span>
        {isUpolad && (
          <input
            type="file"
            ref={fileInputRef}
            accept={Filetype ? Filetype : "image/*"}
            style={{ display: "none" }}
            onChange={FileUpload}
          />
        )}
      </Button>
    </div>
  );
};

export default GradiantButton;
